import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            getMainTheme: 'global/getMainTheme',
            getGlobalColors: 'global/getGlobalColors',
            getIcons: 'global/getIcons',
            getLogos: 'global/getLogos',
        }),
        getTheme() {
            return this.$cookies.get('user-theme') || this.getMainTheme?.replace(/_/, '-');
        },
        getSchemeColor() {
            return this.getTheme === 'light-theme' ? 'light' : 'dark';
        },
        getFavicon() {
            const themeLogo = this.getTheme === 'light-theme' ? 'logoLight' : 'logoDark';
            return this.getIcons?.favicon || themeLogo;
        },
    },
    methods: {
        getCssVariables() {
            let cssVariables = `:root {`;
            for (const [name, value] of Object.entries(this.getGlobalColors['light_theme'])) {
                cssVariables += `--${name?.replace(/_/g, '-')}: ${value};`;
            }
            cssVariables += `}`;

            cssVariables += `:root body.dark-theme {`;
            for (const [name, value] of Object.entries(this.getGlobalColors['dark_theme'])) {
                cssVariables += `--${name?.replace(/_/g, '-')}: ${value};`;
            }
            cssVariables += `}`;

            cssVariables += `@media screen and (prefers-color-scheme: dark) {`;
            cssVariables += `:root body.dark-theme {`;
            for (const [name, value] of Object.entries(this.getGlobalColors['dark_theme'])) {
                cssVariables += `--${name?.replace(/_/g, '-')}: ${value}; `;
            }
            cssVariables += `}`;
            cssVariables += `}`;

            return cssVariables;
        },
    },
};
